import { z } from 'zod'

export const StoreManagementSettingsSchema = z.object({
  ymarketPricesEnabled: z.boolean(),
  ymarketStockEnabled: z.boolean(),
  wildberriesPricesEnabled: z.boolean(),
  wildberriesStockEnabled: z.boolean(),
}).strict()

export type StoreManagementSettings = z.infer<typeof StoreManagementSettingsSchema>

export const PriceBatchChannelSchema = z.enum(['ymarket', 'wildberries', 'ozon'])
export const PriceBatchModeSchema = z.enum(['percent', 'per_gram', 'price'])

const PriceBatchItemSchema = z.object({
  id: z.string().uuid().nullable(),
  productId: z.string().uuid(),
  channel: PriceBatchChannelSchema,
  state: z.string(),
  previewHash: z.string().nullable(),
  currentPrice: z.number().int().nullable(),
  currentOldPrice: z.number().int().nullable(),
  newPrice: z.number().int().nullable(),
  newOldPrice: z.number().int().nullable(),
  difference: z.number().int().nullable(),
  realisedPerGram: z.string().nullable(),
  weightGrams: z.string().nullable(),
  notInStock: z.boolean(),
  refusalReason: z.string().nullable(),
  refusalMessage: z.string().nullable(),
  reconcileState: z.string().nullable(),
  operationId: z.string().uuid().nullable(),
}).strict()

export const PriceBatchPreviewSchema = z.object({
  batchHash: z.string().length(64),
  items: z.array(PriceBatchItemSchema),
  summary: z.object({
    changedCount: z.number().int().nonnegative(),
    skippedCount: z.number().int().nonnegative(),
    totalDifference: z.number().int(),
  }).strict(),
}).strict()

export const PriceBatchApplySchema = z.object({
  batchId: z.string().uuid(),
  batchHash: z.string().length(64),
  state: z.enum(['queued', 'running', 'completed', 'failed']),
  operationId: z.string().uuid(),
}).strict()

export const PriceBatchStatusSchema = z.object({
  batchId: z.string().uuid(),
  batchHash: z.string().length(64),
  state: z.enum(['queued', 'running', 'completed', 'failed']),
  items: z.array(PriceBatchItemSchema),
}).strict()

export type PriceBatchChannel = z.infer<typeof PriceBatchChannelSchema>
export type PriceBatchMode = z.infer<typeof PriceBatchModeSchema>
export type PriceBatchItem = z.infer<typeof PriceBatchItemSchema>
export type PriceBatchPreview = z.infer<typeof PriceBatchPreviewSchema>
export type PriceBatchApply = z.infer<typeof PriceBatchApplySchema>
export type PriceBatchStatus = z.infer<typeof PriceBatchStatusSchema>
